module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-vi.75db636327c59a16b3f0.svg";